<template>
  <footer
    class="
      h-24
      w-full
      mt-6
      bg-big3dBlack
      text-white
      flex
      items-center
      justify-center
    "
  >
    &copy; 2021 BIG3D. All Rights Reserved
  </footer>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "Footer",
});
</script>

<style lang="postcss" scoped></style>
